import React, { useRef, useState } from 'react'
import MessageEmoji from './MessageEmoji'
import Moment from 'react-moment'
import { useDispatch, useSelector } from 'react-redux'
import TaskMessage from './TaskMessage';
import PrivateMessage from './PrivateMessage';
import { useNavigate, useParams } from 'react-router-dom';
import { Get_My_Counter, getONLYUSERSDATA } from '../../../Utils/Common';

import MessageFiles from './MessageFiles';
import { FaTasks } from 'react-icons/fa';
import { removeMessage, setActiveMsg, setPopup, update_messages } from '../../../redux/messageSlice';
import { useMutation } from '@apollo/client';
import { Flagged_UnFlagged_Mutation, Remove_this_line } from '../../../apollo/Mutations';
import toast from 'react-hot-toast';
import AiReplyIcon from '../../../media/images/svg/openai.svg';
export default function Message({ data: v, seperator, privateMsgQuickView, is_group_msg, thread = false, is_reply_head = false, quickMsg = false, type = '' }) {
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const { filter_name, slug } = useParams()
    const { user, allUsers, total_unread, reply_main_msg } = useSelector((state) => state.message);
    const [isExpanded] = useState(false);

    const [showSingleMsgTime, setShowSingleMsgTime] = useState(false);
    const [is_show, setIs_show] = useState(false);
    // let is_noti = v.msg_type?.indexOf('log_notify') > -1;
    let is_secret = quickMsg ? false : v.is_secret;
    let is_deleted = v.has_delete?.includes(user?.id) || v.has_delete?.includes('for_all')
    let is_task = v.msg_type?.includes('task_msg')
    // let task_noti = v.msg_type?.includes('task_notification')
    let is_AI = v.msg_type?.includes('aiReplyReq')


    const [pressTimer, setPressTimer] = useState(null);
    const longPressDuration = 500;
    const pressStartTime = useRef(null);
    const moved = useRef(false); // <-- Track finger movement
    const startPos = useRef({ x: 0, y: 0 });

    const handleLongPressStart = (msg, e) => {
        if (msg?.msg_type?.includes('log_notify') || msg?.msg_type?.includes('call') || is_reply_head) return;

        // Safe access: touch start exists only on mobile
        if (e?.touches && e.touches.length > 0) {
            startPos.current = {
                x: e.touches[0].clientX,
                y: e.touches[0].clientY
            };
        }

        moved.current = false;
        pressStartTime.current = Date.now();

        const timer = setTimeout(() => {
            if (!moved.current) {
                dispatch(setActiveMsg(msg));
                dispatch(setPopup({ key: 'msg_drawer', value: true }));
            }
        }, longPressDuration);

        setPressTimer(timer);
    };


    const handleTouchMove = (e) => {
        if (!pressStartTime.current) return;

        const threshold = 10; // movement threshold in px
        const x = e.touches[0].clientX;
        const y = e.touches[0].clientY;

        if (Math.abs(x - startPos.current.x) > threshold ||
            Math.abs(y - startPos.current.y) > threshold) {
            moved.current = true;
            clearTimeout(pressTimer); // cancel long-press on scroll
        }
    };

    const handleLongPressEnd = () => {
        clearTimeout(pressTimer);
        pressStartTime.current = null;
    };

    const [removeLine] = useMutation(Remove_this_line)

    const removeThisLine = async (msg) => {
        try {
            let { data } = await removeLine({
                variables: {
                    input: {
                        conversation_id: msg.conversation_id,
                        msg_id: msg.msg_id,
                        is_reply_msg: msg.is_reply_msg,
                        participants: msg.participants,
                    }
                }
            })
            if (data.remove_this_line.status) {
                dispatch(removeMessage(msg))
                toast.success(data.remove_this_line.message)
            }
        } catch (error) {
            console.log("🚀 ~ removeThisLine ~ error:", error)
        }
    }

    const handleMsgTitle = () => {
        dispatch(setActiveMsg(v));
        dispatch(setPopup({ key: 'title_popup', value: { key: 'msg_title', state: true } }))
    }
    // const handleLinkTitle = (link) => {
    //     dispatch(setActiveMsg(link));
    //     dispatch(setPopup({ key: 'title_popup', value: { key: 'link_title', state: true } }))
    // }

    function removeHTMLTags(str) {
        return str.replace(/<\/?[^>]+(>|$)/g, "");
    }

    function convertHTMLEntity(text) {
        if (!text) return '';

        const span = document.createElement('span');
        const xssPatterns = /<script|<img|<iframe|javascript:|onerror=|onclick=|alert\(|eval\(/i;

        const placeholder = '__BR_PLACEHOLDER__';
        const replacedText = text.replace(/<br\s*\/?>/gi, placeholder);

        if (xssPatterns.test(replacedText)) {
            const escaped = replacedText
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;')
                .replace(new RegExp(placeholder, 'g'), '<br />');

            return `<div class="xss-content">${escaped}</div>`;
        }

        return replacedText
            .replace(/&[#A-Za-z0-9]+;/gi, (entity) => {
                span.innerHTML = entity;
                return span.innerText;
            })
            .replace(new RegExp(placeholder, 'g'), '<br />');
    }

    const returnLinkDesign = (_msg) => {
        if (!_msg?.msg_body?.length) return null;
        // const _body = _msg.msg_body.replace(/```html|```/g, '').replace(/\\n/g, '')?.trim()
        const _body = _msg.msg_body
            .replace(/```html|```/g, '')  // Remove markdown code blocks
            .replace(/\\n/g, '<br />')     // Convert `\n` to `<br />` for HTML rendering
            ?.trim();

        const msg_body =
            (removeHTMLTags(v.msg_body).length > 800 && !is_reply_head && !is_AI) ?
                isExpanded
                    ? `${_body} <span class="text-blue-500 cursor-pointer hover:underline read-less">Read less</span>`
                    : `${_body.substring(0, 800)} <span class="text-blue-500 cursor-pointer hover:underline read-more">... Read more</span>`
                : _body;
        // Convert message to string and sanitize unnecessary tags
        const msg_body1 = msg_body.toString();
        const sanitizedBody = convertHTMLEntity(msg_body1.replace(/<p dir="ltr">/gi, ''));

        // Function to wrap links with custom design or remove target for mentions
        const wrapLinkWithDesign = (match, href, text) => {

            // Check if the link matches any `link_data` for custom design
            let matchedLink = _msg?.link_data?.find((u) => u.url === href);
            if (matchedLink) {

                return `
                    <div class="p-2.5 dark:p-0 group rounded-md border dark:border-none border-teal-200 bg-white bgSurfaceDarkSec">
                        <div class="msg_link_container flex flex-col">
                            <div class="flex msg_title_link LinkBar items-center -mt-1" >
                                <div class="linkIconsGray -ml-1 mr-1 ${matchedLink.user_id !== user?.id ? 'hidden' : ''}" style="background-size: 16px 16px;"></div>
                                <p class="add_link_title text-text-body font-bold !text-sm dark:text-white ${matchedLink.user_id !== user?.id ? 'hidden' : ''}" data-id="${matchedLink.url_id}" data-title="${matchedLink.title || ''}">${matchedLink.title || 'Write a title'}</p>
                                <span class="editTpenLink text-teal-600 cursor-pointer" style="${matchedLink.user_id !== user?.id ? 'display: none;' : 'cursor: pointer; background-size: 16px 16px;'}" data-id="${matchedLink.url_id}"></span>
                            </div>
                            <div class="${matchedLink.user_id !== user?.id ? 'ml-0' : 'ml-6'}">
                                <a class="msg_link_url text-sm dark:text-white" target="_blank" href="${matchedLink.url}">${text}</a>
                            </div>
                        </div>
                    </div>
                `;
            }

            // If no custom design is needed, return the original link
            return match;
        };

        //   <span class="editTpenLink text-teal-600 cursor-pointer" style="${matchedLink.user_id !== user?.id ? 'display: none;' : 'cursor: pointer;'}" data-id="${matchedLink.url_id}"/>

        // Match links using regex and replace with custom design or remove target for mentions
        const linkRegex = /<a\s+(?:[^>]*?href=["'](https?:\/\/(?:www\.)?[^"']*)["'][^>]*?)>(.*?)<\/a>/gi;
        let styledResult = sanitizedBody.replace(linkRegex, (match, href, text) => {
            return wrapLinkWithDesign(match, href, text);
        });

        // Handle line breaks for consistent rendering
        styledResult = styledResult.replace(/(<br\s*\/?>)+/gi, '<br>');

        // Emoji replacement (optional)
        const emojiRegex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b]|\u23e9-\u23fa)/gim;
        styledResult = styledResult.replace(emojiRegex, (match) => {
            return `<span class="newemoji mx-[2px]" style="font-size:14px;">${match}</span>`;
        });

        return styledResult;
    };

    const handleClickOnMsg = (e) => {
        if (is_reply_head) return;
        if (e.target.classList.contains('editTpenLink')) {
            const link = v.link_data.filter(l => l.url_id === e.target.dataset.id)?.[0]
            console.log("🚀 ~ handleClickOnMsg ~ link:", link)
            dispatch(setPopup({ key: 'active_link', value: link }))
            dispatch(setPopup({ key: 'title_popup', value: { key: 'link_title', state: true } }));
        }

        if (e.target.classList.contains("genarated_img")) {

            // 	// Set the image source and open the preview
            if (v.img_url) {
                //props.setpreviewImageSrc(props.data.img_url);
                console.log(1001, "Ai Image clicked", v.img_url);
                // dispatch(set_showAiPopup(true));
                // dispatch(set_showAiUrl(v.img_url));

            }
        }

        if (e.target.classList.contains("download_ai_img")) {
            console.log("Image Download clicked", v);
            // if (v.img_url) {
            //     let imageName = getImageNameFromUrl(v.img_url);
            //     AfileDownload(v.img_url, imageName);
            // }
        }

        // if (e.target.classList.contains("read-more")) {
        //     setIsExpanded(true);
        // } else if (e.target.classList.contains("read-less")) {
        //     setIsExpanded(false);
        // }

        setShowSingleMsgTime(!showSingleMsgTime)
    }

    const processedContent = returnLinkDesign(v);

    const viewUser = () => {
        if (v.sender !== "c4439ad9-67b3-4414-a5a9-87a0d0153c58") {
            if (v.sender === user?.id) {
                dispatch(setPopup({ key: 'user_profile', value: true }))
            } else {
                navigate('#mention_' + v.sender)
            }
        }
    }

    const checkUserImage = () => {
        let hasImage = (v?.senderimg?.indexOf('img.png') > -1) ? false : true;
        let _Simg = is_AI && v.sender === "c4439ad9-67b3-4414-a5a9-87a0d0153c58" ? AiReplyIcon : v?.senderimg;

        return (
            hasImage ?
                <img src={_Simg} width={40} height={40} loading="lazy" alt='sender' title="sender" />
                :
                <div className="text-white font-bold">{v?.sendername?.charAt(0)}</div>

        )
    }

    const [updateFlagUnFlag] = useMutation(Flagged_UnFlagged_Mutation)
    const flag_action = async () => {
        updateFlagUnFlag({
            variables: {
                input: {
                    conversation_id: v?.conversation_id,
                    msg_id: v?.msg_id,
                    is_add: v?.has_flagged?.indexOf(user?.id) > -1 ? 'no' : 'yes'
                }
            }

        });
        dispatch(removeMessage(v))
        // if (filter_name && filter_name === 'flag') {
        // } else {
        //     dispatch(
        //         update_messages({
        //             conversation_id: v?.conversation_id,
        //             msg_id: v?.msg_id,
        //             fields: {
        //                 has_flagged: v?.has_flagged?.indexOf(user?.id) > -1 ? [] : [user?.id]
        //             },
        //             is_reply_msg: reply_main_msg ? 'yes' : 'no',
        //             msg_type: v?.msg_type
        //         })
        //     )
        // }
        // dispatch(setPopup({ key: 'msg_drawer', value: false }))
    }

    const removeFlag = () => {
        if (type === 'flagged') {
            flag_action()
        }
    }

    return (
        (!is_task || (is_task && (v.task_data?.created_by === user?.id || v.task_data?.assign_to?.includes(user?.id) || v.task_data?.observers?.includes(user?.id)))) &&
        <>
            {seperator !== '' && <div className="msgSeparator" ><p className={`z-[1] dark:text-white bg-teal-100 bgSurfaceDarkSec`}>{seperator}</p></div>}
            <div className={`senderMessage mb-3 ${privateMsgQuickView ? 'px-0' : 'px-4'}`}>
                {!is_group_msg &&
                    <div className='flex items-center mb-2'>
                        <div className='w-10 h-10 rounded-full !bg-teal-700 flex justify-center items-center overflow-hidden'>
                            {checkUserImage()}
                        </div>
                        <div className="msg_info !mt-0">
                            <div className="sender_info">
                                <div>
                                    <p onClick={viewUser} className="sender_name !w-auto dark:!text-white">{v.sendername}</p>
                                    <div className='flex'>
                                        <p className="msg_time dark:!text-white"><Moment format="h:mm A">{v?.created_at}</Moment></p>
                                        <p className="msg_delivered dark:!text-white">&nbsp; - Delivered</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <div className="msg_body_text group mb-2">
                    {/* For deleted message */}
                    {is_deleted &&
                        <div className='noSelect msg_txt msg_text_bg !text-sm group-hover:!bg-[#f5f9fc] !bg-[#F3F4F6] p-2 rounded-lg w-fit text-gray-600 bgSurfaceDarkSec dark:group-hover:!bg-[#4e4e4e] dark:text-white max-w-[100%]'>
                            {v.has_delete?.includes('for_all') ? 'Message deleted by the sender' : 'You deleted this message'} <span onClick={() => removeThisLine(v)} className="text-[#ff0000] cursor-pointer">(Remove this line)</span>
                        </div>
                    }
                    {!is_deleted &&
                        <>
                            {!is_task ?
                                <>
                                    {is_secret && thread ?
                                        "" :
                                        <>
                                            {v.url_base_title && v.url_base_title !== '' &&
                                                <p className="titleBar">
                                                    <span className="msgLinkTitle dark:text-teal-400"> {v.url_base_title} </span>
                                                    {/*  */}
                                                    {/* {(!quickMsg && v.sender === user.id) && <FaPencilAlt onClick={() => handleMsgTitle()} className='editTpen !text-xs mt-0.5' />} */}
                                                    {(!quickMsg && v.sender === user.id) && <span onClick={() => handleMsgTitle()} className='messageEditActive !text-xs -mt-0.5' />}
                                                </p>
                                            }
                                        </>
                                    }
                                    {(is_secret && !thread && filter_name !== 'private') && <PrivateMessage v={v} />}
                                    {(is_secret && (thread || filter_name === 'private')) &&
                                        <div className="flex justify-start flex-wrap">
                                            <ul className="secrectUserName">
                                                {getONLYUSERSDATA(allUsers, v.secret_user, 'name').map(u =>
                                                    <li key={u}>{u}</li>
                                                )}
                                                {(!thread && v.sender === user?.id) &&
                                                    <button onClick={() => { dispatch(setActiveMsg(v)); dispatch(setPopup({ key: 'userList', value: { key: 'private_participants', state: true } })) }} className="h-[22px] text-[12px] bg-teal-600 text-white rounded-[5px] pt-[2px] mt-[2px] px-2 withTooltip">
                                                        <i className="fas fa-users bg-teal-600 text-white"></i> Add/Edit
                                                    </button>
                                                }
                                            </ul>
                                        </div>
                                    }

                                    {(!is_secret || (is_secret && (thread || filter_name === "private"))) && (
                                        <div className='relative'>
                                            {showSingleMsgTime && <p className='text-[#6d6c6c] text-xs dark:text-white'><Moment format="h:mm A">{v?.created_at}</Moment></p>}
                                            <div
                                                className="noSelect msg_txt msg_text_bg !text-sm group-hover:!bg-[#f5f9fc] !bg-[#F3F4F6] bgSurfaceDarkSec p-3 break-all rounded-lg w-fit text-gray-700 dark:group-hover:!bg-[#4e4e4e] dark:text-white max-w-[100%]"
                                                onMouseDown={(e) => handleLongPressStart(v, e)}
                                                onMouseUp={handleLongPressEnd}
                                                onTouchStart={(e) => handleLongPressStart(v, e)}
                                                onTouchEnd={handleLongPressEnd}
                                                onTouchMove={handleTouchMove}
                                                onClick={handleClickOnMsg}
                                                dangerouslySetInnerHTML={{ __html: processedContent }}
                                            ></div>
                                            {
                                                v.has_flagged?.includes(user?.id) && <div onClick={removeFlag} className='FlagiconRed !absolute !top-[6px] !left-[325px] !text-[8px] !bg-[length:12px_12px]' />
                                            }
                                        </div>
                                    )}

                                    {/* Edited Message */}

                                    {!thread &&
                                        <>
                                            {(v.edit_history && v.edit_history !== '' && Array.isArray(v.edit_history) /* && props.edit_msg_id !== v.msg_id*/) &&
                                                <div className={"show_edited_msg " + is_show}>
                                                    <span className="show_more_reply dark:text-teal-400" onClick={() => setIs_show(!is_show)}>{is_show ? 'Click to collapse edit trail' : 'Click to view edit trail'}</span>
                                                    {v.edit_history.map((m, i) => <div className="edit_history_msg" key={i} dangerouslySetInnerHTML={{ __html: returnLinkDesign(m) }} />)}
                                                </div>
                                            }
                                        </>
                                    }
                                    <MessageFiles msg={v} is_secret={is_secret} is_reply_head={is_reply_head} />
                                    <MessageEmoji msg_id={v.msg_id} has_emoji={v.has_emoji} />
                                </>
                                :
                                <TaskMessage msg={v} is_reply_head={is_reply_head} />
                            }



                            {!thread &&
                                <>
                                    {(!quickMsg && v.has_reply > 0) &&
                                        <div className="msgReplySection relative" onClick={() => navigate(`/connect/${slug}/reply/${v?.msg_id}`)}>
                                            {is_task ? <FaTasks className="text-teal-600 dark:text-white absolute left-0 top-0.5 !text-[13px] mr-1" /> : <div style={{ backgroundSize: "18px" }} className='rep_left'></div>}
                                            <p className='leading-4'>
                                                <span style={{ backgroundSize: "18px" }} className={`${is_task ? 'text-teal-600 ml-4' : 'rep_left'} !text-xs ${Get_My_Counter(total_unread, 'smru', v.conversation_id, v.msg_id) > 0 && 'unread !text-[#e91e63]'}`} data-length={v.has_reply}> {is_task ? 'Task notifications' : 'View threaded chat'} {`(${Get_My_Counter(total_unread, 'smru', v.conversation_id, v.msg_id) > 0 ? Get_My_Counter(total_unread, 'smru', v.conversation_id, v.msg_id) + ' of ' : ''}${v.has_reply})`} </span>
                                                <span className={`rep_mid !text-xs dark:!text-white`}>
                                                    &nbsp;Last reply <Moment fromNow>{v.last_reply_time}</Moment> from{" "}
                                                    <span className='text-teal-500 dark:text-teal-400'>{v.last_reply_name}</span>
                                                </span>
                                            </p>
                                        </div>
                                    }
                                </>
                            }
                        </>
                    }
                </div>

            </div>
        </>
    )
}
